<template>
  <section class="source-header">
    <h3 class="source-header__title">
      <slot />
    </h3>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped>
.source-header {
  &__title {
    @include font(20, 24, 600);
    text-align: center;
    text-transform: uppercase;
    color: #2b2b2b;

    @include bigMobile {
      @include font(16, 19, 700);
    }
  }
}
</style>
